
const padIntStart = (int, width) => {
    
    const result = ('' + int).padStart(width, 0);
    return result;
};

export default padIntStart;
